import React from 'react';
import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import Loader from "./Loader"
import useAuth from '../hooks/useAuth';

interface AuthGuardProps {
  children?: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();


  if (!isAuthenticated) {
    window.location = process.env.REACT_APP_LOGIN_PAGE_URL as any
    return <Loader/>
  }

  return (
    <>
      {children}
    </>
  );
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
